export let postSyncNewMessageSingular = "Vp2LGc";
export let postSyncNewConversationSingular = "Pr66Sd";
export let postSyncNewMessagefirstPlural = "U2uMfc";
export let postSyncNewConversationfirstPlural = "uKWHBb";
export let postSyncNewMessageSecondPlural = "KrdPxc";
export let postSyncNewConversationSecondPlural = "O0ztQb";
export default {postSyncNewMessageSingular,postSyncNewConversationSingular,postSyncNewMessagefirstPlural,postSyncNewConversationfirstPlural,postSyncNewMessageSecondPlural,postSyncNewConversationSecondPlural};